import React from 'react';
import { FadeIn } from './FadeIn';
import { Download, Send, DollarSign } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'DESCARGAS',
    desc: 'Obtienes la guía y eliges uno de los platos sugeridos para tu zona.',
    icon: <Download className="w-6 h-6 text-kitchen-brown" data-id="element-83" />
  }, {
    num: '2',
    title: 'PUBLICAS',
    desc: 'Copias y pegas el guion de venta rápida en tus grupos de vecinos.',
    icon: <Send className="w-6 h-6 text-kitchen-brown" data-id="element-84" />
  }, {
    num: '3',
    title: 'COBRAS',
    desc: 'Confirmas los pedidos, cocinas con el dinero de la venta y entregas a mediodía.',
    icon: <DollarSign className="w-6 h-6 text-kitchen-brown" data-id="element-85" />
  }];
  return <section className="bg-kitchen-white py-12 md:py-24 px-5 md:px-12 lg:px-24" data-id="element-86">
      <div className="max-w-5xl mx-auto" data-id="element-87">
        <FadeIn data-id="element-88">
          <h2 className="font-lora text-2xl md:text-4xl font-bold text-kitchen-brown text-center mb-10 md:mb-16" data-id="element-89">
            Cómo funciona en 3 simples pasos ⚙️
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative" data-id="element-90">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-kitchen-amber/30 -z-10" data-id="element-91"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-92">
              <div className="flex flex-col items-center text-center relative" data-id="element-93">
                <div className="w-18 h-18 md:w-24 md:h-24 bg-kitchen-amber rounded-full flex items-center justify-center mb-4 md:mb-6 shadow-lg border-4 border-white relative" data-id="element-94">
                  <span className="absolute -top-2 -right-2 w-7 h-7 md:w-8 md:h-8 bg-kitchen-terracotta text-white rounded-full flex items-center justify-center font-bold text-base md:text-lg border-2 border-white" data-id="element-95">
                    {step.num}
                  </span>
                  {step.icon}
                </div>
                <h3 className="font-lora text-xl md:text-2xl font-bold text-kitchen-brown mb-2 md:mb-4" data-id="element-96">
                  {step.title}
                </h3>
                <p className="font-nunito text-base md:text-lg text-kitchen-brown/80" data-id="element-97">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}